import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

import { EventTypes } from 'src/app/core/constants/event-types';
import { LoggerService } from 'src/app/core/services/logger.service';
import { SuperAdminAuditDto } from '../../../../core/api/models/super-admin-audit-dto';
import { TranslationService } from './../../../../i18n/translation.service';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';

@Component({
    selector: 'app-super-admin-audits-details',
    templateUrl: './super-admin-audits-details.component.html',
    styleUrls: ['./super-admin-audits-details.component.scss'],
    imports: [BaseIndexModule]
})
export class SuperAdminAuditsDetailsComponent implements OnInit {
  title = 'common.detail';
  fields = 'pages.superAdminAudits.fields.';
  legends = 'pages.superAdminAudits.legends.';

  loading;

  protected onDestroy$ = new Subject<void>();

  @Input('model') model: SuperAdminAuditDto = {};

  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  constructor(
    public translationService: TranslationService,
    protected loggerService: LoggerService
  ) {}

  ngOnInit() {
    try {
      window.scroll(0, 0);
    } catch (error) {
      this.loggerService.logError(
        'app-super-admin-audits-details',
        error,
        EventTypes.infrastructure
      );
    }
  }

  onClose() {
    this.output_closPage.emit(true);
  }
}
